import React, { useEffect, useState } from "react";
import { superadminAPI } from "../../../api/superadminClient";

export default function OverviewPanel({ onError }) {
  const [overview, setOverview] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    superadminAPI
      .getOverview()
      .then((resp) => setOverview(resp.data))
      .catch((err) =>
        onError(err.response?.data?.message || "Failed to load overview"),
      )
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return <div className="superadmin-loading">Loading...</div>;

  return (
    <section className="superadmin-cards">
      <article className="superadmin-card">
        <h3>Total Tenants</h3>
        <strong>{overview?.totalTenants ?? 0}</strong>
      </article>
      <article className="superadmin-card">
        <h3>Active Tenants</h3>
        <strong>{overview?.activeTenants ?? 0}</strong>
      </article>
      <article className="superadmin-card">
        <h3>Pending Payments</h3>
        <strong>{overview?.pendingPayments ?? 0}</strong>
      </article>
      <article className="superadmin-card">
        <h3>Due In 7 Days</h3>
        <strong>{overview?.next7DaysDueCount ?? 0}</strong>
      </article>
    </section>
  );
}
